"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileReporting = exports.UserProfileOperations = exports.UserProfileALMTrader = exports.UserProfileALMManager = exports.UserProfileRiskManager = exports.UserProfileMultiEntityNostro = exports.UserProfileSingleCurrency = exports.UserProfileTwoCurrency = void 0;
const constants_1 = require("./constants");
const risk_metric_1 = require("./risk-metric");
class UserProfileTwoCurrency {
    getProfileFamily() {
        return 'SURVIVAL_HORIZON';
    }
    getProfileType() {
        return 'TWO_CURRENCY';
    }
    getBaseCurrency() {
        return this.baseCurrency;
    }
    getCurrencies() {
        return [this.firstCurrency, this.secondCurrency];
    }
    getMetricTypes() {
        return [constants_1.MetricTypes.SURVIVAL_HORIZON, constants_1.MetricTypes.NET_BREACH, constants_1.MetricTypes.GROSS_BREACH, constants_1.MetricTypes.UNEXPECTED];
    }
    usePollingService() {
        return true;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
}
exports.UserProfileTwoCurrency = UserProfileTwoCurrency;
class UserProfileSingleCurrency {
    getProfileFamily() {
        return 'SURVIVAL_HORIZON';
    }
    getProfileType() {
        return 'SINGLE_CURRENCY';
    }
    getBaseCurrency() {
        return this.baseCurrency;
    }
    getCurrencies() {
        return [this.currency];
    }
    getMetricTypes() {
        return [constants_1.MetricTypes.SURVIVAL_HORIZON, constants_1.MetricTypes.NET_BREACH, constants_1.MetricTypes.GROSS_BREACH, constants_1.MetricTypes.UNEXPECTED,
            constants_1.MetricTypes.THROUGHPUT, constants_1.MetricTypes.FOREIGN_CURRENCY_NETFLOW, constants_1.MetricTypes.SUSPENSE_BALANCE, constants_1.MetricTypes.PASS_THROUGH_WAIT];
    }
    usePollingService() {
        return true;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
}
exports.UserProfileSingleCurrency = UserProfileSingleCurrency;
class UserProfileMultiEntityNostro {
    constructor() {
        this.currencies = [];
        this.desks = [];
    }
    getProfileFamily() {
        return 'SURVIVAL_HORIZON';
    }
    getProfileType() {
        return 'MULTI_ENTITY_NOSTRO';
    }
    getBaseCurrency() {
        return this.baseCurrency;
    }
    getCurrencies() {
        return this.currencies;
    }
    getMetricTypes() {
        return [constants_1.MetricTypes.ACTUAL_BALANCE, constants_1.MetricTypes.ACTUAL_BALANCE, constants_1.MetricTypes.ACTUAL_BALANCE, constants_1.MetricTypes.ACTUAL_BALANCE,];
    }
    usePollingService() {
        return true;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
    getDesks() {
        return this.desks;
    }
    getLocationName() {
        return this.locationName;
    }
}
exports.UserProfileMultiEntityNostro = UserProfileMultiEntityNostro;
class UserProfileRiskManager {
    constructor() {
        this.currencies = [];
    }
    getProfileFamily() {
        return 'RISK_MANAGER';
    }
    getProfileType() {
        return 'RISK_MANAGER';
    }
    getBaseCurrency() {
        return this.baseCurrency;
    }
    getCurrencies() {
        return this.currencies;
    }
    getMetricTypes() {
        return [];
    }
    getRiskMetricCategories() {
        return Object.keys(risk_metric_1.RISK_METRIC_CATEGORIES)
            .map((key) => {
            const riskMetricCategoriesAny = risk_metric_1.RISK_METRIC_CATEGORIES;
            ;
            return riskMetricCategoriesAny[key];
        });
    }
    usePollingService() {
        return false;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
}
exports.UserProfileRiskManager = UserProfileRiskManager;
class UserProfileALMManager {
    constructor() {
        this.currencies = [];
    }
    getProfileFamily() {
        return 'ALM';
    }
    getProfileType() {
        return 'ALM_MANAGER';
    }
    getBaseCurrency() {
        return this.baseCurrency;
    }
    getCurrencies() {
        return this.currencies;
    }
    getMetricTypes() {
        return [];
    }
    usePollingService() {
        return false;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
}
exports.UserProfileALMManager = UserProfileALMManager;
class UserProfileALMTrader {
    constructor() {
        this.currencies = [];
    }
    getProfileFamily() {
        return 'ALM';
    }
    getProfileType() {
        return 'ALM_TRADER';
    }
    getBaseCurrency() {
        return this.baseCurrency;
    }
    getCurrencies() {
        return this.currencies;
    }
    getMetricTypes() {
        return [];
    }
    usePollingService() {
        return false;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
}
exports.UserProfileALMTrader = UserProfileALMTrader;
class UserProfileOperations {
    getProfileFamily() {
        return 'OPERATIONS';
    }
    getProfileType() {
        return 'OPERATIONS';
    }
    getBaseCurrency() {
        return 'BASE';
    }
    getCurrencies() {
        return [];
    }
    getMetricTypes() {
        return [];
    }
    usePollingService() {
        return false;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
}
exports.UserProfileOperations = UserProfileOperations;
class UserProfileReporting {
    getProfileFamily() {
        return 'REPORTING';
    }
    getProfileType() {
        return 'REPORTING';
    }
    getBaseCurrency() {
        return 'BASE';
    }
    getCurrencies() {
        return [];
    }
    getMetricTypes() {
        return [];
    }
    usePollingService() {
        return false;
    }
    getUserStartTimeHour() {
        return this.startHour;
    }
    getUserEndTimeHour() {
        return this.endHour;
    }
    isReportDashboardDesigner() {
        return this.reportDashboardDesigner;
    }
    isReportDashboardViewer() {
        return this.reportDashboardViewer;
    }
    isReportDashboardAdmin() {
        return this.reportDashboardAdmin;
    }
    getLicense() {
        return this.license;
    }
}
exports.UserProfileReporting = UserProfileReporting;
//# sourceMappingURL=profiles.js.map